export default "__VITE_ASSET__CGT6ebc0__"